//import { View } from "native-base";
import { View } from "dripsy";

export default View;
